import { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { employeeService } from '../../../services/employeeService';
import ProfileView from '../components/ProfileView';
import Loading from '../../../shared/Loading';
import { normalizeUserModel } from '../../../shared/userModel';

const ProfilePage = () => {
  const { logout, user } = useAuth();
  const [profile, setProfile] = useState(() => normalizeUserModel(user));
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState('');

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 3000);
  };

  useEffect(() => {
    setProfile((prev) => normalizeUserModel({ ...(user || {}), ...(prev || {}) }));
  }, [user]);

  useEffect(() => {
    employeeService.getEmployeeProfile()
      .then((res) => {
        setProfile(normalizeUserModel({ ...(user || {}), ...(res.data || {}) }));
      })
      .catch(() => showToast('Gagal memuat profil'))
      .finally(() => setLoading(false));
  }, [user]);

  const handleUpdateProfile = async ({ name, phone }) => {
    try {
      await employeeService.updateProfile({ name, phone });
      setProfile((prev) => normalizeUserModel({ ...(prev || {}), name, phone }));
      showToast('Profil berhasil diperbarui');
    } catch (err) {
      showToast(err?.message || 'Gagal memperbarui profil');
    }
  };

  if (loading) return <Loading />;

  return (
    <>
      <ProfileView user={profile} onLogout={logout} onUpdateProfile={handleUpdateProfile} />
      {toast && <div className="toast">{toast}</div>}
    </>
  );
};

export default ProfilePage;
